export const question = {
  id: 1780,
  institution: "UFPR",
  year: 2016,
  state: "PR",
  content:
    "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam vehicula ante felis, eget ullamcorper nisi imperdiet vitae. Proin pharetra sem quis egestas fermentum.</p>",
  alternatives: [
    "<p>Proin eu porta ligula, in volutpat nulla. Sed placerat porta felis, a fermentum lorem tincidunt in.</p>",
    "<p>Duis sodales, tortor id pellentesque congue, justo orci cursus nunc, vulputate rutrum lorem velit sit amet elit.</p>",
    "<p>Sed magna est, tempor scelerisque aliquet id, ultricies vel orci.</p>",
    "<p>Ut elit lectus, viverra sit amet placerat sit amet, tempor vestibulum tortor.</p>",
    "<p>Suspendisse ultrices eu sapien a bibendum. Ut viverra posuere nibh eu hendrerit.</p>"
  ],
  examNumber: 1,
  correctAlternative: "d",
  testDay: null,
  reviewedAt: "2021-03-29T08:09:49.710-03:00",
  unknownYear: false,
  supportText: null,
  topics: [
    {
      id: 3,
      slug: "portugues",
      name: "Português",
      children: [
        {
          id: 3,
          slug: "interpretacao-de-texto",
          name: "Interpretação de texto",
          group: { name: "Linguagens", slug: "linguagens" }
        }
      ],
      group: { name: "Linguagens", slug: "linguagens" }
    }
  ],
  resourceTopics: [
    {
      id: 16920,
      topic: { id: 3, name: "Português", slug: "portugues", group: [Object] }
    },
    {
      id: 16921,
      topic: {
        id: 84,
        name: "Interpretação de texto",
        slug: "interpretacao-de-texto",
        group: null
      }
    }
  ],
  resolution: null
};
